import { Component, OnInit } from '@angular/core';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Router } from '@angular/router';
import { BusinessInfo } from '../Models/BusinessInfoResponse';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit {
  BusinessInfos: any;
  UserId: string = "";
  BusinessInfo: any;
  BusinessInfoData: BusinessInfo[] = [];
  SelectedBusinessInfoName: string = "";
  CheckBusinessInfoId: string = "";
  UserNameAsPhoto: string = "";
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  i:number=0;
  Index:number=0;
  isPopupVisible: boolean = false;
  onButtonClick(index:number): void {
    this.Index=index;
    this.isPopupVisible = true;  // Show the popup
    
  }

  closePopup(): void {
    this.isPopupVisible = false;  // Hide the popup
  }

  ngOnInit(): void {
    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.BusinessInfo = this.getSafeValue(localStorage.getItem("BusinessInfo"));
    this.i= Number(this.getSafeValue(localStorage.getItem("index")));
    // this.BusinessInfo = localStorage.getItem("BusinessInfo");
    this.service.GetBusinessInfoDetails(this.UserId).subscribe(data => {
        this.BusinessInfoData = data;
        this.BusinessInfos = data[this.i];
        this.CheckBusinessInfoId=this.BusinessInfos.BusinessInfoId;
        this.SetActiveBusinessInfoDetails(this.BusinessInfos.BusinessInfoId,this.BusinessInfos.BusinessInfo_BusinessName);
        localStorage.setItem("SelectedBusinessInfoName", this.SelectedBusinessInfoName);
        localStorage.setItem("CheckBusinessInfoId",this.CheckBusinessInfoId);
        this.SelectedBusinessInfoName = this.BusinessInfos.BusinessInfo_BusinessName;
        this.UserNameAsPhoto = `${Array.from(this.SelectedBusinessInfoName)[0]}`;
    });
  }
  private showSuccess(message: string): void {
    this.toastr.success(message, 'Success', {
      toastClass: 'ngx-toastr toast-success'
    });
  }
  private showError(message: string): void {
    this.toastr.error(message, 'Error', {
      toastClass: 'ngx-toastr toast-error'
    });
  }
SelectedBusinessInfoId:number=0;
  SetActiveBusinessInfoDetails(BusinessInfoId:number,BusinessName:string){
    this.SelectedBusinessInfoName=BusinessName;
    this.SelectedBusinessInfoId=BusinessInfoId;
    localStorage.setItem("CheckBusinessInfoId",""+ BusinessInfoId);
  }

  index:string="";
  onSwitch(i: number , operation : any , infoid : any) {
    if (this.BusinessInfoData && this.BusinessInfoData.length > i && operation == false && infoid == false) {
      this.BusinessInfos = this.BusinessInfoData[i];
      this.index=String(i);
      this.SelectedBusinessInfoName = this.BusinessInfos.BusinessInfo_BusinessName;
      this.CheckBusinessInfoId=this.BusinessInfos.BusinessInfoId;
      localStorage.setItem("CheckBusinessInfoId",this.CheckBusinessInfoId);
      localStorage.setItem("index",this.index);
      localStorage.setItem("SelectedBusinessInfoName", this.SelectedBusinessInfoName);
      this.UserNameAsPhoto = `${Array.from(this.SelectedBusinessInfoName)[0]}`; 
      this.ngOnInit();
      this.isSecondSidebarExpanded = !this.isSecondSidebarExpanded;
      this.isPopupVisible = false; 
      window.location.reload();
      this.showSuccess('Switched to Business Successful');
    }
    else if(operation){
      this.BusinessInfos = this.BusinessInfoData[infoid];
      this.SelectedBusinessInfoName = String(operation);
      localStorage.setItem("CheckBusinessInfoId",infoid);
      console.log("Managage Business CheckBusinessInfoId",infoid);
      localStorage.setItem("index",String(i));
      localStorage.setItem("SelectedBusinessInfoName", this.SelectedBusinessInfoName);
      this.UserNameAsPhoto = `${Array.from(this.SelectedBusinessInfoName)[0]}`; 
      this.isPopupVisible = false; 
      this.showSuccess('Switched to Business Successful');
      this.ngOnInit();
    } 
    else {
      console.error("Invalid business index or BusinessInfoData is undefined");
      this.showError('Failed to Switch Business . Please check your selection.');
    }
  }


  screenWidth: any;
  screenHeight: any;
  isExpanded = false;

  toggleSidebar() {
    this.isExpanded = !this.isExpanded;
  }
  isSecondSidebarExpanded: boolean = false; // Second sidebar state

  toggleSecondSidebar() {
    this.isSecondSidebarExpanded = !this.isSecondSidebarExpanded;
  }
  logout(){
    const pushNotificationToken = localStorage.getItem("PushNotificationToken");
    localStorage.clear();
    localStorage.setItem("PushNotificationToken", pushNotificationToken || '');
  }
  constructor(public service: SharkifyAiSerivceService, public router: Router,private toastr: ToastrService,) {
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    };
  }
}
